module.exports = __webpack_public_path__ + "media/images/landkit/illustrations/illustration-5-ead88876331bfed08c7bde7e3553f8e7.png";